import { render, staticRenderFns } from "./AppControlText.vue?vue&type=template&id=1dec08c8&"
import script from "./AppControlText.vue?vue&type=script&lang=js&"
export * from "./AppControlText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports